import { render, staticRenderFns } from "./TemplateData.vue?vue&type=template&id=528f5c07&"
import script from "./TemplateData.vue?vue&type=script&lang=js&"
export * from "./TemplateData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports